import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-loading-app',
    templateUrl: './loading-app.component.html',
    styleUrls: ['./loading-app.component.css'],
    standalone: true,
    imports: []
})
export class LoadingAppComponent implements OnInit {
  logoImage = '';
  path = '';
  externalUrl = '';
  appName = '';
  showRetry = false;

  private appNames: { [key: string]: string } = {
    'dxpro': 'DxPro',
    'vennhealth': 'VennHealth',
    'precise': 'PRECISE',
    'biomarkers': 'Biomarkers',
    'predict': 'PREDICT',
    'countyfips': 'County FIPS',
    'tcri': 'TCRI'
  };

  constructor(private activatedRoute: ActivatedRoute) {
    this.activatedRoute.url.subscribe((u) => {
      this.logoImage = activatedRoute.snapshot.data['logoImage'];
      this.externalUrl = activatedRoute.snapshot.data['externalUrl'];
      this.path = activatedRoute.snapshot.url[0].path.toLowerCase();
      this.appName = this.appNames[this.path] || this.path.toUpperCase();
    });
  }

  ngOnInit() {
    // Start the launch process after a brief animation delay
    setTimeout(() => {
      this.launchApp();
    }, 3000);

    // Show retry button if launch takes too long (e.g. 10 seconds)
    setTimeout(() => {
      this.showRetry = true;
    }, 10000);
  }

  launchApp() {
    if (this.externalUrl) {
      window.location.href = this.externalUrl;
    }
  }

  retry() {
    this.launchApp();
  }
}
